<template>
  <div class="font-14-991">
    <b-popover :target="`service_point_info_${service_point.id}`" triggers="hover" placement="top" :custom-class="'custom-popover-service-point-info'">
      <div class="popover-service-point-info-container">
        {{ $t("service_point_info_popover_text")}}
      </div>
    </b-popover>
  </div>
</template>

<script>
export default {
  name: "PopoverServicePointRight",
  props : ["service_point"]
}
</script>